import { connect } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName, Button, Stack } from '@optimus-web/core';
import EnterpriseBuilderScreenStep from '../../../EnterpriseBuilderScreenStep';
import { addNewEntity as addNewEntityAction } from '../../../actions/steps';

interface OwnProps {
    scope: string;
}

interface StateProps {
    addNewEntity: (step: EnterpriseBuilderScreenStep, scope: string) => void;
}

type ResourceOverviewActionButtonsProps = OwnProps & StateProps;

const ResourceOverviewActionButtons = ({ addNewEntity, scope }: ResourceOverviewActionButtonsProps) => {
    const handleAddCategoryClick = () => addNewEntity(EnterpriseBuilderScreenStep.ResourceCategories, scope);
    const handleAddFloorClick = () => addNewEntity(EnterpriseBuilderScreenStep.Floors, scope);

    return (
        <Stack itemAlignment="center" alignment="end" spacing="100">
            <Button variant="ghost" onClick={handleAddCategoryClick} icon={IconName.Add} type="submit">
                <LocalizedText textKey={TextKey.NewSpaceCategory} />
            </Button>
            <Button variant="ghost" onClick={handleAddFloorClick} icon={IconName.Add} type="submit">
                <LocalizedText textKey={TextKey.NewFloor} />
            </Button>
        </Stack>
    );
};

export default connect(undefined, {
    addNewEntity: addNewEntityAction,
})(ResourceOverviewActionButtons);
